exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap-text{white-space:normal!important;word-break:break-word}#create .v-speed-dial{position:absolute}#create .v-btn--floating,.outer{position:relative}.outer{display:inline-block;margin:0 10px;padding-top:inherit+100px}.inner{top:104%;left:50%;-webkit-padding-before:30px;padding-block-start:30px;-webkit-padding-after:10px;padding-block-end:10px}.icorta,.inner{position:absolute}.icorta{margin:0 auto;height:226px;color:#fff;left:92%;top:95%;margin-left:-110px;margin-top:-15px}.rotate{-webkit-transform:translateX(-50%) translateY(-50%) rotate(-90deg);transform:translateX(-50%) translateY(-50%) rotate(-90deg)}", ""]);

// exports
